import {
  PanelsTopLeft,
  LayoutGrid,
  QrCode,
  PackageCheck,
  Package,
  Truck,
  FileText,
  History,
  Settings,
  Users,
  User,
  Warehouse,
  Boxes,
  ClipboardList,
  Shield,
  ShieldCheck,
  ScanLine,
  CircleHelp,
  Building2,
  PackageOpen,
  FileSignature,
} from 'lucide-react';

import type { LucideIcon } from 'lucide-react';

const REGISTRY: Record<string, LucideIcon> = {
  LayoutDashboard: PanelsTopLeft, // Replace LayoutDashboard with PanelsTopLeft
  LayoutGrid,
  QrCode,
  PackageCheck,
  Package,
  Truck,
  FileText,
  Users,
  User,
  Settings,
  ScanLine,
  History,
  Warehouse,
  Boxes,
  ClipboardList,
  Shield,
  ShieldCheck,
  Building2,
  PackageOpen,
  FileSignature,
};

/**
 * Per-entry defaults, keyed by menu `code`, for when the server sends no icon
 * name or one this bundle doesn't know (e.g. a workspace whose menu row was
 * backfilled or edited without one).
 */
const CODE_ICONS: Record<string, LucideIcon> = {
  'dispatched-lots': PackageOpen,
  'commercial-info': FileSignature,
};

export const FALLBACK_ICON: LucideIcon = CircleHelp;

export function navIcon(name: string | undefined, code?: string): LucideIcon {
  return (name && REGISTRY[name]) || (code && CODE_ICONS[code]) || FALLBACK_ICON;
}